import styled, { css } from 'styled-components';
import { spacer4, spacer12, spacer16, screenXsMax, screenSmMin, spacer20 } from '@spotify-internal/encore-foundation';
export default styled.div.withConfig({
  displayName: "LegalContainer",
  componentId: "sc-6ycz2q-0"
})(["flex:1;@media (max-width:", "){flex-basis:100%;margin-top:", ";margin-bottom:", ";}@media (min-width:", "){margin-top:-", ";margin-bottom:-", ";}", ";"], screenXsMax, spacer12, spacer20, screenSmMin, spacer4, spacer4, function (props) {
  return props.legalStrict && css(["flex-basis:100%;@media (min-width:", "){margin-bottom:", ";}"], screenSmMin, spacer16);
});